import React from "react";
import { HelmetProvider } from "@dr.pogodin/react-helmet";
import SkipNavLink from "../../components/SkipNavLink";
import SiteHeader from "../../components/SiteHeader";
import SiteFooter from "../../components/SiteFooter";
import "./BaseLayout.scss";
import JQI from "jqi";

const BaseLayout: React.FC<JQI.BaseLayoutProps> = ({
  children,
  headerProps,
  footerProps,
}) => {
  return (
    <HelmetProvider>
      <div className="base-layout">
        <SkipNavLink />
        <SiteHeader {...headerProps} />
        <main id="main-content">
          {children}
        </main>
        <SiteFooter {...footerProps} />
      </div>
    </HelmetProvider>
  );
};

export default BaseLayout;